import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AppPaths } from './enums/app-paths.enum';
import { AuthGuard } from './guards/auth.guard';
import { AppointmentGuard } from './guards/appointment.guard';
import { HideSpinnerGuard } from './guards/hide-spinner.guard';
import { AuthHideSpinnerGuard } from './guards/auth-hide-spinner.guard';
import { dataValidationTokenGuard } from './guards/data-validation-token.guard';

const routes: Routes = [
  {
    path: AppPaths.AUTH,
    loadComponent: () => import('./components/login/login.component').then(mod => mod.LoginComponent)
  },
  {
    path: AppPaths.SOCIAL,
    loadChildren: () => import('./modules/social-login/social-login.module').then(m => m.SocialLoginModule),
    canActivate: [HideSpinnerGuard],
  },
  {
    path: AppPaths.CREDENTIAL_VALIDATION,
    loadComponent: () => import('./components/credential-validation/credential-validation.component').then(mod => mod.CredentialValidationComponent),
    canActivate: [HideSpinnerGuard]
  },
  {
    path: AppPaths.REGISTRATION,
    loadChildren: () => import('./modules/registration/registration.module').then(m => m.RegistrationModule),
    canActivate: [HideSpinnerGuard],
  },
  {
    path: AppPaths.DATA_VALIDATION,
    loadComponent: () => import('./components/data-validation-token/data-validation-token.component').then(mod => mod.DataValidationTokenComponent),
    canActivate: [AuthGuard, AuthHideSpinnerGuard]
  },
  {
    path: AppPaths.TERMS_AND_CONDITIONS,
    loadComponent: () => import('./components/terms-and-conditions/terms-and-conditions.component').then(mod => mod.TermsAndConditionsComponent),
    canActivate: [AuthGuard, AuthHideSpinnerGuard, dataValidationTokenGuard]
  },
  {
    path: AppPaths.WARNING,
    loadComponent: () => import('./components/warning/warning.component').then(mod => mod.WarningComponent),
    canActivate: [AuthGuard, AuthHideSpinnerGuard, dataValidationTokenGuard]
  },
  {
    path: AppPaths.DOCTOR_DETAIL + "/:id",
    loadComponent: () => import('./components/doctor-detail/doctor-detail.component').then(mod => mod.DoctorDetailComponent),
    canActivate: [AuthGuard, AuthHideSpinnerGuard, dataValidationTokenGuard]
  },
  { 
    path: AppPaths.NAVBAR, 
    loadChildren: () => import('./modules/navbar/navbar.module').then(m => m.NavbarModule),
    canActivate: [AuthGuard, AuthHideSpinnerGuard, dataValidationTokenGuard],
  },
  { 
    path: AppPaths.SETTINGS, 
    loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule),
    canActivate: [AuthGuard, AuthHideSpinnerGuard, AppointmentGuard, dataValidationTokenGuard],
  },
  { 
    path: AppPaths.CALL, 
    loadChildren: () => import('./modules/call/call.module').then(m => m.CallModule),
    canActivate: [AuthGuard, AuthHideSpinnerGuard, dataValidationTokenGuard],
  },
  {
    path: AppPaths.APPOINTMENT_END,
    loadComponent: () => import('./components/call-ended/call-ended.component').then(mod => mod.CallEndedComponent),
    canActivate: [HideSpinnerGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
